import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by YE DIGITAL"
      links={[
        {
          key: 'BusOne',
          title: 'BusOne',
          href: 'https://smartcity.ye-digital.com/busstop/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
